// Normaliza texto: minúsculas y sin acentos, para búsquedas tolerantes.
export const normalize = (s) =>
  String(s ?? "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

// Construye un "pajar" de texto recorriendo en profundidad cualquier valor
// (objetos, arrays, primitivos). Solo incorpora valores, no las claves.
export const buildHaystack = (...vals) => {
  const parts = [];
  const walk = (v) => {
    if (v === null || v === undefined) return;
    if (Array.isArray(v)) return v.forEach(walk);
    if (typeof v === "object") return Object.values(v).forEach(walk);
    parts.push(String(v));
  };
  vals.forEach(walk);
  return normalize(parts.join(" "));
};

// Todos los términos de la consulta deben aparecer en el contenido.
export const matchesQuery = (query, hay) => {
  const q = normalize(query).trim();
  if (!q) return true;
  const h = typeof hay === "string" ? hay : buildHaystack(hay);
  return q.split(/\s+/).every((t) => h.includes(t));
};
